import Firebase from '../../lib/Firebase';
import Firestore from '../../lib/Firestore';

export default {
  all () {
    return Firebase.firestore().collection('hotels')
      .get()
      .then((docs) => {
        return Firestore.getCollectionData(docs);
      });
  },

  add (city) {
    const cityObj = {
      name: city,
      contact: {},
      configs: { active : false},
    
    };

    return Firebase.firestore().collection('hotels')
      .add(cityObj);
  }
};



// WEBPACK FOOTER //
// ./src/pages/hotel/service.js